import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";

import { useAppDispatch } from "../../app/hook";
import { AuthRTKService } from "../../app/services/auth-rtk.service";
import { BillingRTKService } from "../../app/services/billing-rtk.service";
import { ChatbotRTKService } from "../../app/services/chatbot-rtk.services";
import { resetStore } from "../../app/store";
import { MultiLanguageUrl } from "../../constants/multiLanguage.constant";
import { handleResetAppearance } from "../../features/appearance/appearanceSlice";
import { logout } from "../../features/auth/auth.slice";
import { handleResetWizard } from "../../features/bot/botSlice";
import { resetDashboard } from "../../features/dashboard.slice";
import { resetCreate, resetPackage } from "../../features/knowledge.slice";
import useAppLocalStorage from "../../hooks/useAppLocalStorage";
import useAuth from "../../hooks/useAuth";

const Logout = () => {
  const { i18n } = useTranslation();
  const localStorage = useAppLocalStorage();
  const dispatch = useAppDispatch();
  const auth = useAuth();

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  useEffect(() => {
    localStorage.removeItem(`${import.meta.env.VITE_STORAGE_PREFIX}_service`);

    resetStore().then(() => {
      auth.logout();

      queryClient.clear();

      dispatch(AuthRTKService.util.resetApiState());
      dispatch(BillingRTKService.util.resetApiState());
      dispatch(ChatbotRTKService.util.resetApiState());

      dispatch(resetDashboard());
      dispatch(resetCreate());
      dispatch(resetPackage());
      dispatch(handleResetWizard());
      dispatch(handleResetAppearance());
      dispatch(logout());

      localStorage.setItem(`${import.meta.env.VITE_STORAGE_PREFIX}_token`, "");

      navigate(`/${MultiLanguageUrl[i18n.language] || "en-US"}`);
    });
  }, [auth, navigate, queryClient, localStorage]);

  return null;
};

export default Logout;
